<template>
  <div>
    <ParseForm :formParams='formParams' :emit='emit' formId='videoBusiness' :opCode='opCode' ref='bus' :funcClick='bindClickInterface'></ParseForm>
    <CustomDialog ref='userTableLayerDialog' :element='dialog.element.eleUserTable' :styles='dialog.styles' :messages='dialog.messages'>
      <template v-slot:dialog-content>
        <UserTableLayer ref="userTableLayer"></UserTableLayer>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import ParseForm from '../../../subscriberconfig/util/parseFormNew/ParseForm';
import CustomDialog from '../../../common/CustomDialog';
import UserTableLayer from './dialog/userTableLayer';
import bus from './bus';

export default {
  name: 'U_VideoBussiness',
  components: {
    ParseForm,
    CustomDialog,
    UserTableLayer
  },
  props: [
    'formParams',
    'reMountPage',
    'info',
    'gmsInfo',
    'opCode'
  ],
  data() {
    return {
      dialog: {
        element: {
          eleUserTable: {
            target: this.$refs.userTableLayer,
            refName: 'eleUserTable',
            buttonGroup: [
              { click: this.closeTablePage, buttonModel: { content: this.$t("MCS.cancle") } },
              { click: this.saveData, buttonModel: { content: this.$t("MCS.confirm"), isPrimary: true } }
            ],
            isClose: true,
            title: this.$t('MCS.userInfo'),
          },
        },
        styles: {
          width: '700px',
          height: '500px',
          visible: false,
          model: true,
          zIndex: 1001
        },
        messages: this.$t("MCS.userInfo")
      },
      dialogParamName: '',
      funcMap: ''
    };
  },
  methods: {
    getDatas() {
      return this.$refs.bus.getDatas();
    },
    validateResult() {
      return this.$refs.bus.validateResult();
    },
    emit(attr) {
      bus.$emit('eventBus', attr);
    },
    reMount() {
      this.$refs.bus.reMount();
      this.bindClickInterface();
    },
    saveData() {
      this.$refs.bus.setData(this.dialogParamName, this.$refs.userTableLayer.getClickData() === undefined ? '' : this.$refs.userTableLayer.getClickData().userNum);
      this.closeTablePage();
    },
    closeTablePage() {
      this.$refs.userTableLayerDialog.clear();
      this.$refs.userTableLayerDialog.close();
    },
    $bindEmergentNum(key) {
      this.funcMap.set(key, () => {
        this.$refs.userTableLayer.getGridData(this.info, 5);
        this.$refs.userTableLayerDialog.show();
        this.dialogParamName = key;
      });
    },
    $bindSwitchFunc(key) {
      const _resMap = new Map();
      switch (key) {
        case 'mcvideoPermission': {
          _resMap.set(0, this.$checkBoxBitFunc('mcvideoBackHaul'));
          break;
        }
        default:
      };
      this.funcMap.set(key, _resMap);
    },
    $checkBoxBitFunc(...paramName) {
      const _resArr = [];
      const $this = this;
      if (paramName.length === 0) return;
      _resArr[0] = () => {
        paramName.forEach((item) => {
          $this.$refs.bus.setAttrByName(item, 'disabled', true);
          $this.$refs.bus.setAttrByName(item, 'readonly', false);
          $this.$refs.bus.setReadonlyNoGray(item);
        });
      };
      _resArr[1] = () => {
        paramName.forEach((item) => {
          $this.$refs.bus.setAttrByName(item, 'disabled', false);
          $this.$refs.bus.setAttrByName(item, 'readonly', true);
          $this.$refs.bus.setReadonlyNoGray(item);
        });
      };
      return _resArr;
    }
  },
  computed: {
    bindClickInterface() {
      this.funcMap = new Map();
      this.$bindEmergentNum('mcvideoBackHaul');
      this.$bindSwitchFunc('mcvideoPermission');
      return this.funcMap;
    },
  },
  mounted() {
    bus.$on('eventBus', (attr) => {
      if (this.$refs.bus === undefined || this.$refs.bus.templetCover === undefined) return;
      this.$refs.bus.templetCover(attr);
    });
  }
};
</script>

<style scoped>

</style>
